import React, { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useFileIntelligenceEnabled } from 'hooks/file-intelligence-settings-hooks';
import { useGetApiV5FilesPendingReview } from '@liscio/api';
import { ReviewModal } from './components';

export interface AIFileReviewButtonProps {
  /**
   * Old ugly dependency to refresh the list in parent component
   */
  component: any;
}

export const AIFileReviewButton: React.FC<AIFileReviewButtonProps> = ({
  component,
}) => {
  const theme = useTheme();
  const { isFileIntelligenceEnabled } = useFileIntelligenceEnabled();
  const { enableAiFileRenaming, enableAiTagging } = useFlags();
  const [isPreviewModalVisible, setIsPreviewModalVisible] = useState(false);

  // Only show the review count for firms with File Intelligence enabled and
  // at least one file-AI flag on (LISD-2765; previously gated by the AI
  // Features setting, LISD-2498).
  const isEnabled = Boolean(
    isFileIntelligenceEnabled && (enableAiFileRenaming || enableAiTagging),
  );

  const { data: filesToReview, isLoading } = useGetApiV5FilesPendingReview(
    undefined,
    { query: { enabled: isEnabled } },
  );

  if (!isEnabled || isLoading) {
    return null;
  }

  const count = filesToReview?.count || 0;
  const noun = count === 1 ? 'file needs review' : 'files need review';
  const primaryColor = theme.palette.primary.main;

  return (
    <>
      <button
        type="button"
        className="btn"
        style={{
          backgroundColor: '#fff',
          color: primaryColor,
          border: `1px solid ${primaryColor}`,
          marginRight: '1rem',
        }}
        onClick={() => setIsPreviewModalVisible(true)}
      >
        <strong>{count}</strong> {noun}
      </button>

      {isPreviewModalVisible && (
        <ReviewModal
          onClose={() => setIsPreviewModalVisible(false)}
          component={component}
        />
      )}
    </>
  );
};
